import { RootState } from '@/App/store';

export const selectViolationStateMap = (state: RootState) => state.violations.map;
